var render = function render(){var _vm=this,_c=_vm._self._c;return (
		_vm.message.Attributes &&
			_vm.message.Attributes.MessageType === 'BookingCreated'
	)?_c('v-card',{staticClass:"nyGreenLight text-left chatWidget",class:{ 'widget-right': _vm.view !== 'received' }},[_c('div',{staticClass:"pa-4"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"flex-grow-0 pr-1"},[_c('BookingDateTimeDisplay',{attrs:{"date":_vm.message.Attributes.BookingTime}})],1),_c('div',{staticClass:"flex-grow-1 pl-1 d-flex flex-column justify-space-between"},[_c('div',[_c('div',{staticClass:"mb-2 poppins-semibold CardTitleSize"},[(
								_vm.message.Attributes.BookingTypeId ===
									_vm.BookingTypesEnum.FREE
							)?_c('span',[_vm._v(_vm._s(_vm.$t("freeVisit")))]):_vm._e(),(
								_vm.message.Attributes.BookingTypeId ===
									_vm.BookingTypesEnum.NORMAL
							)?_c('span',[_vm._v(_vm._s(_vm.$t("normalVisit")))]):_vm._e(),(
								_vm.message.Attributes.BookingTypeId ===
									_vm.BookingTypesEnum.MEALPLAN
							)?_c('span',[_vm._v(_vm._s(_vm.$t("mealPlan")))]):_vm._e()]),(
							_vm.view === 'received' &&
								_vm.message.Attributes.BookingTypeId !==
									_vm.BookingTypesEnum.FREE
						)?_c('div',{staticClass:"poppins-regular InfoText"},[_vm._v(" ti ricordiamo di effettuare il pagamento entro 2 giorni dall’appuntamento, in caso contrario la prenotazione verrà annullata ")]):_vm._e()]),_c('div',{staticClass:"text-right"},[(_vm.view === 'received')?_c('v-btn',{attrs:{"text":"","to":'/Patients/Agenda/' +
								_vm.message.Attributes.BookingId}},[_vm._v(_vm._s(_vm.$t("common.details"))+" ")]):_c('v-btn',{attrs:{"text":"","to":'/AreaNutritionists/Bookings/' +
								_vm.message.Attributes.BookingId}},[_vm._v(_vm._s(_vm.$t("common.details"))+" ")])],1)])])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }